
import { Component, Inject, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Quote } from '../../../models/quote.model';
import { AlertService, DialogType } from '../../../services/alert.service';
import * as _ from 'lodash';
import { NavItem } from '../../../models/nav-item';
import { NgxSpinnerService } from 'ngx-spinner';
import { QuoteHomeComponent } from '../quote-home.component';
import { BenefitClassification } from '../../../models/benefit-classification.model';
import { Observable } from 'rxjs';

@Component({
    selector: 'create-edit-quote-modal',
    template: require('./create-edit-quote-modal.component.html'),
    styles: [require('./create-edit-quote-modal.component.css')]
})
export class CreateEditQuoteModalComponent implements OnInit {
    currentQuote: Quote = {
        
    } as any;
    isCreatNew: boolean;
    public  _ = _;
    customers = [];
    orgs = [];
    services = [];
    benefits = [];
    benefitsGroupByType = [];
    benefitsGroupByClassification = [];
    contractTemplates = [];
    selectedBenefitType;
    businessTypes = [];
    benefitClassifications: Observable<BenefitClassification[]>;
    currentBenefitClassificationId = 2;

    navItem: NavItem =
        {
            displayName: '',
            iconName: '',
            children: []
        }
        ;

    navItemContracts: NavItem =
        {
            displayName: '',
            iconName: '',
            children: []
        }
        ;


    constructor(private alertService: AlertService, private apiService: ApiService,
        private spinner: NgxSpinnerService,
        public dialogRef: MatDialogRef<CreateEditQuoteModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentQuote.quoteId == undefined);
        this.currentQuote = data.currentQuote;
        if (!this.currentQuote.plannedStartDate) {
            this.currentQuote.plannedStartDate = new Date();
        }
        dialogRef.disableClose = true;
    }

    ngOnInit() {
        this.getBusinessTypes();
        this.getOrgs();
        this.getServices();
        this.getBenefits();
        this.getContractTemplates();
        this.benefitClassifications = this.apiService.getBenefitClassifications();
    }

    classificationChanged() {
        this.getBenefits();
    }

    getOrgs() {
        this.apiService.getOrgs().subscribe(r => {
            this.orgs = r;
        })
    }

    getBusinessTypes() {
        this.apiService.getBusinessTypes().subscribe(r => {
            this.businessTypes = r;
        })
    }

    getCustomers() {
        this.apiService.getCustomers().subscribe(r => {
            this.customers = r;
        })
    }

    getServices() {
        this.apiService.getServices().subscribe(r => {
            this.services = r;
        })
    }

    getBenefits() {
        this.spinner.show();
        this.apiService.getBenefits().subscribe(r => {
            this.spinner.hide();
            r = _.filter(r, { benefitClassificationId: this.currentBenefitClassificationId})
            var temp = _.groupBy(r, i => { return i.benefitType.name });

            this.benefitsGroupByType = _.map(Object.keys(temp), key =>
            {
                return { key, value: _.orderBy(temp[key], 'benefitName') }
            });

            this.benefitsGroupByType = _.orderBy(this.benefitsGroupByType,'key')
            this.navItem.children = [];
            _.each(this.benefitsGroupByType, i =>
            {
                this.navItem.children.push({
                    displayName: i.key,
                    iconName: "",
                    children: _.sortBy(i.value.map(benefit => {
                        return {
                            displayName: benefit.benefitName,
                            cost: benefit.cost,
                            price: benefit.price,
                            benefitId: benefit.benefitId,
                            data: benefit,
                            clickEvent: (err, res) => {
                                this.currentQuote.quoteBenefits.push({ benefit: benefit, benefitId: benefit.benefitId });
                            },
                            hoverEvent: (err, res) => {
                                console.log(res);
                            }
                        }
                    }), ['name']),
                });
            });

        })
    }

    getContractTemplates() {
        this.apiService.getContractTemplates().subscribe(r => {
            this.contractTemplates = r;

            _.each(this.contractTemplates, i => {
                this.navItemContracts.children.push({
                    displayName: i.name,
                    iconName: "",
                    clickEvent: (err, res) => {
                        this.currentQuote.contracts.push({ contractTemplate: i, createdOn: new Date() } as any);
                    }
                })
            });

            //console.log(this.navItemContracts)

        })
    }

    addContract() {
        this.currentQuote.contracts.push({ contractTemplate: {}, createdOn: new Date()} as any);
    }

    removeContract(index) {
        this.currentQuote.contracts.splice(index,1)
    }
    removeQB(index) {
        this.currentQuote.quoteBenefits.splice(index, 1)
    }

    cancel() {
        this.alertService.showDialog("Are you sure you want to cancel ?", DialogType.confirm, val => {

            this.dialogRef.close();
        });
    }

    ok() {
        if (!this.isCreatNew) {
            this.spinner.show();
            this.apiService.updateQuote(this.currentQuote).subscribe(r => {
                if (r) {
                    this.spinner.hide();
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Quote successfully");
                    QuoteHomeComponent.QuotesChanged.emit(this.currentQuote);
                }
            });
        } else {

            var newQuote = _.cloneDeep(this.currentQuote);

            //newQuote.customerId = newQuote.customer.customerId;
     
            _.each(newQuote.quoteServices, qs => {
                delete qs.service;
            })

            _.each(newQuote.quoteBenefits, qb => {
                //qb.quote = newQuote;
                delete qb.benefit;
            })

            _.each(newQuote.contracts, c => {
                if (c.contractTemplate) {
                    c.contractTemplateId = c.contractTemplate.contractTemplateId;
                    delete c.contractTemplate;
                }
            })

            this.apiService.createQuote(newQuote).subscribe(r => {
                if (r) {
                    this.dialogRef.close(r);
                    this.alertService.showMessage("Create Quote successfully");
                }
            });
        }
    }

    selectBenefitChange(qb) {

        this.currentQuote.quoteBenefits.push(qb);
    }

    getQuoteServicesByType(type: number) {
        var result = _.filter(this.currentQuote.quoteServices, function (s) { return s.service.serviceTypeId == type; });
        return result;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-home/create-edit-quote-modal/create-edit-quote-modal.component.ts